<template>
    <div class="select-container">
        <div class="inner-content">
            <div class="page-header">
                <div class="big-title">商品库</div>
                <div class="page-subtitle">脚本关联商品一览</div>
            </div>
            <div class="select-box">
                <el-table
                    class="goods-table-desktop"
                    :data="infoList"
                    :header-cell-style="tableHeaderStyle"
                    :cell-style="tableCellStyle"
                    style="background-color: rgb(7, 9, 50);"
                >
                    <template slot="empty">
                        <div class="table-empty">
                            <div class="empty-icon-wrap">
                                <i class="el-icon-goods"></i>
                            </div>
                            <p class="empty-text">暂无关联商品</p>
                        </div>
                    </template>
                    <el-table-column prop="name" label="排列序号" width="150">
                        <div class="table-index" slot-scope="scope">{{ scope.$index + 1 }}</div>
                    </el-table-column>
                    <el-table-column label="商品信息" width="200">
                        <router-link
                            :to="{ path: '/goodDetail', query: { id: scope.row.goods_id } }"
                            target="_blank"
                            class="good-info"
                            slot-scope="scope"
                        >
                            <div class="good-img">
                                <img :src="scope.row.getGoodsInfo.goods_master_img" alt="" />
                            </div>
                            <div class="good-title" :title="scope.row.getGoodsInfo.goods_name">
                                <div class="text-overflow">
                                    {{ scope.row.getGoodsInfo.goods_name }}
                                </div>
                            </div>
                        </router-link>
                    </el-table-column>
                    <el-table-column prop="goods_sku" label="商品SKU">
                        <template slot-scope="scope">
                            <span>{{ scope.row.getGoodsInfo.goods_sku }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="日常价">
                        <template slot-scope="scope">
                            &yen;{{ scope.row.getGoodsInfo.goods_market_price }}
                        </template>
                    </el-table-column>
                    <el-table-column label="直播间价">
                        <template slot-scope="scope">
                            &yen;{{ scope.row.getGoodsInfo.goods_discount_price }}
                        </template>
                    </el-table-column>
                    <el-table-column label="佣金比例(利润率）" width="140">
                        <template slot-scope="scope">
                            {{ scope.row.getGoodsInfo.goods_commission_rate }}%
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <router-link
                                :to="{ path: '/live/selection/detail', query: { id: scope.row.goods_id } }"
                                target="_blank"
                                class="see-btn"
                                >查看数据
                            </router-link>
                        </template>
                    </el-table-column>
                </el-table>

                <el-pagination
                    class="selection-pagination"
                    background
                    :current-page="listPages.currentPageNum"
                    :page-size="listPages.eachPageNum"
                    layout="prev, pager, next, jumper"
                    :total="listPages.total"
                    :pager-count="7"
                    @current-change="pageCurrentChange"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { live_script_goods } from "@/utils/apis";

export default {
    name: "LiveSelection",
    data() {
        return {
            infoList: [],
            listPages: {
                currentPageNum: 1,
                eachPageNum: 10,
                total: 0,
            },
            tableHeaderStyle: {
                fontWeight: "normal",
                height: "60px",
                color: "#fff",
                fontSize: "14px",
                background: "#0C0E3F",
            },
            tableCellStyle: {
                fontSize: "14px",
                color: "#fff",
                height: "80px",
                background: "#070932",
            },
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            let script_id = localStorage.getItem("scriptId");
            let param = {
                script_id: script_id,
                page: this.listPages.currentPageNum,
                limit: this.listPages.eachPageNum,
            };
            live_script_goods(param)
                .then((res) => {
                    if (res.code === 200) {
                        this.infoList = res.data.list;
                        this.listPages.total = res.data.total;
                    } else {
                        this.$message.warning(res.msg);
                    }
                })
                .catch(() => {});
        },
        pageCurrentChange(val) {
            this.listPages.currentPageNum = val;
            this.getList();
        },
    },
};
</script>

<style scoped lang="scss">
.select-container {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    max-width: 100%;
    overflow-x: hidden;
}

.inner-content {
    margin: 20px;
    flex: 1;
    height: 1%;
    min-height: 0;
    display: flex;
    flex-direction: column;
    position: relative;
    box-sizing: border-box;
    max-width: 100%;
}

.page-header {
    margin-bottom: 16px;
}

.big-title {
    line-height: 1.2;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
}

.page-subtitle {
    margin-top: 6px;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.45);
}

.select-box {
    height: 1%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.table-index {
    font-size: 14px;
}

.good-info {
    display: flex;
    align-items: center;

    .good-img {
        width: 60px;
        height: 60px;
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f6f6f6;
        flex-shrink: 0;

        img {
            max-width: 100%;
            max-height: 100%;
        }
    }

    .good-title {
        margin-left: 10px;
        width: 1%;
        flex: 1;
        min-width: 0;

        .text-overflow {
            color: #fff;
        }
    }
}

.see-btn {
    display: inline-block;
    padding: 10px;
    color: #2821fc;
    font-weight: 500;
    white-space: nowrap;

    &:hover {
        color: #534dfd;
    }
}

.goods-table-desktop {
    width: 100%;

    .table-empty {
        padding: 48px 16px;
        color: rgba(255, 255, 255, 0.5);
        font-size: 14px;
    }

    .table-empty .empty-icon-wrap {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background: rgba(75, 69, 255, 0.15);
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 12px;

        i {
            font-size: 28px;
            color: #4b45ff;
        }
    }

    &:before {
        content: none;
    }

    ::v-deep .el-table__empty-block {
        background: #070932;

        .el-table__empty-text {
            color: #fff;
        }
    }

    ::v-deep .el-table__body-wrapper {
        background: #070932;
    }

    ::v-deep th.el-table__cell.is-leaf {
        border-bottom: none;
    }

    ::v-deep td.el-table__cell {
        border-bottom: 1px solid #262963;

        &:first-child {
            border-left: 1px solid #262963;
        }

        &:last-child {
            border-right: 1px solid #262963;
        }
    }
}

.selection-pagination {
    flex-shrink: 0;
    padding: 20px 0;
    text-align: center;
}
</style>
